import PrimeRiskAssessmentContainer from "./PrimeRiskAssessmentContainer";
import PrimeRiskAssessmentStore from "./PrimeRiskAssessmentStore";

export default PrimeRiskAssessmentStore(PrimeRiskAssessmentContainer);
